<h4>
  <ng-content></ng-content>
</h4>

<button tabIndex="-1" (click)="closeSideSheet.emit()" mat-icon-button>
  <ui-icon faName="xmark" faStyle="light"></ui-icon>
</button>
